import { render, staticRenderFns } from "./StatsKpiRecordItem.vue?vue&type=template&id=7d253f35&scoped=true&"
import script from "./StatsKpiRecordItem.vue?vue&type=script&lang=js&"
export * from "./StatsKpiRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./StatsKpiRecordItem.vue?vue&type=style&index=0&id=7d253f35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d253f35",
  null
  
)

export default component.exports